var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('Welcome')))]),_c('p',{staticClass:"pb-5"},[_vm._v(" "+_vm._s(_vm.$t('Welcome text 1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('Welcome text 2'))+" ")]),_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }